import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { updateBatches } from 'app/shared/features/batch-selector/state/batch.actions';
import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { selectMasterData } from 'app/state/master-data/master-data.selectors';

@Injectable({
    providedIn: 'root',
})
export class BatchEffects {
    syncWithMasterDataStore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMasterDataStore),
            switchMap(() => this.store.select(selectMasterData)),
            map((masterdata) => updateBatches({ batches: masterdata?.batches ?? [] })),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
